import { memo } from 'react';
import { Heading } from '@/hen-ui/atomics/Heading';
import { Link } from '@/hen-ui/atomics/Link';
import { cn } from '@/hen-ui/utils';
import type { NavItem, SubNavPanelStyle } from './types';
import { hasValidHref } from './utils';
import { subNavLabelClass } from './subnav.variants';
import { FOCUS_RING } from './subnav.constants';

interface ColumnLabelProps {
  item: NavItem;
  variant?: 'default' | 'prominent';
  /** Spacing and look of a default label. */
  panelStyle?: SubNavPanelStyle;
}

export const ColumnLabel = memo(function ColumnLabel({
  item,
  variant = 'default',
  panelStyle,
}: ColumnLabelProps) {
  // SubNav uses a denser type scale than Heading h4 defaults — keep overrides
  // so desktop megamenu columns match the designed sizes.
  const baseClass =
    variant === 'prominent'
      ? 'mt-xs text-b3 leading-b3 text-subtext font-bold lg:mt-xxs lg:text-b4 lg:leading-b4 xl:mt-xs xl:text-h4 xl:leading-h4'
      : `mb-xxs text-b5 leading-b5 lg:text-l1 lg:leading-l1 xl:text-b5 xl:leading-b5 ${subNavLabelClass(panelStyle)}`;

  if (hasValidHref(item)) {
    return (
      <Link
        href={item.uri}
        variant='black'
        size='sm'
        underline='none'
        underlineStyle='thin'
        className={cn(baseClass, FOCUS_RING)}
      >
        {item.label}
      </Link>
    );
  }

  return (
    <Heading
      variant='h4'
      color={variant === 'prominent' ? 'subtext' : 'default'}
      className={baseClass}
    >
      {item.label}
    </Heading>
  );
});
